import * as React from 'react';

export const IncompleteIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'5668D5CF-CF08-4632-9991-98C5B65E1837@1x'}</title>
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-1.562 1.5l-2.272 2.273 1.061 1.06L22.5 10.56V22.5H10.56l2.203-2.202-1.061-1.06-2.202 2.2V9.5h11.938zm-4.443 4.445l-2.829 2.828 1.061 1.06 2.828-2.828-1.06-1.06z"
        fill="#6D717E"
        fillRule="evenodd"
      />
    </svg>
  );
};
